import itiriri from 'itiriri';
import { makeAutoObservable, toJS } from 'mobx';

import { asSuccessPromise, getCurrentFreshness, mergeSuccessResult } from '^/types/__ResultType';
import { CameraIDType } from '^/types/cameraTypes';
import { AppContext } from '^/userWeb/types/AppContext';
import { filterNotDefineds } from '^/utils';

const ONE_DAY_TO_MILLISEC = 24 * 60 * 60 * 1000;

const FEW_DAYS_AGO = new Date(
  (new Date()).getTime() - (ONE_DAY_TO_MILLISEC * 3),
);

console.log('FEW_DAYS_AGO: ', FEW_DAYS_AGO);
export class StanzonesListPageViewModel {
  constructor(
    public appContext: AppContext,
    public freshness = getCurrentFreshness(),
    public after: Date = new Date(
      (new Date()).getTime() - (ONE_DAY_TO_MILLISEC * 3),
    ),
  ) {
    makeAutoObservable(this, {
      appContext: false,
    });
  }

  get userToken() {
    return this.appContext.tokenRepo.userToken;
  }

  get myInfo() {
    if (this.userToken.status !== 'success') {
      return this.userToken;
    }
    const myInfoResult = this.appContext
      .myInfoCore
      .myInfo(this.userToken.value, this.freshness);

    return mergeSuccessResult(
      myInfoResult, this.userToken.value,
    );
  }

  get allCams() {
    if (this.myInfo.status !== 'success') {
      return this.myInfo;
    }

    const myInfo = this.myInfo.value[0];
    const userToken = this.myInfo.value[1];
    const userId = myInfo.id;
    const camsRaw = this.appContext.liveCamsListCore.getLiveCams(
      {
        userToken,
        userId,
      },
      this.freshness,
    );
    if (camsRaw.status !== 'success') {
      return camsRaw;
    }
    const camsFilter = itiriri(camsRaw.value)
      .map((camResult) => {
        if (camResult.status !== 'success') {
          return null;
        }
        return camResult.value;
      });
    const cams = filterNotDefineds(camsFilter);
    return asSuccessPromise(cams.toMap((k) => k.id));
  }

  camById(camId: CameraIDType) {
    if (this.allCams.status !== 'success') {
      return null;
    }
    return this.allCams.value.get(camId);
  }

  get stanzonesList() {
    const stanzoneHistoryByCamId = this
      .appContext
      .cowStanzoneListCore
      .getStanzoneHistoryByCamId({
        // after: this.after,
        pushTypes: [
          'JUST_UNLOCKED',
          'LOCKED_FOR_TOO_LONG',
        ],
      });
    if (stanzoneHistoryByCamId.status !== 'success') {
      return stanzoneHistoryByCamId;
    }
    return asSuccessPromise(
      stanzoneHistoryByCamId.value,
    );
  }

  get stanzonesListCollapsed() {
    const stanzonesListResult = this.stanzonesList;
    if (stanzonesListResult.status !== 'success') {
      return stanzonesListResult;
    }

    const groupBySameStatusSince = stanzonesListResult
      .value
      .entries()
      .map(([
        camId,
        stanzoneHistList,
      ]) => {
        const stanzoneHistListGrouped = stanzoneHistList.groupBy((s) => s.sameStatusSince);
        console.log('stanzoneHistList: ', toJS(stanzoneHistList.toArray()));
        console.log('stanzoneHistListGrouped: ', stanzoneHistListGrouped.toArray());
        return [
          camId,
          stanzoneHistList
            .groupBy((s) => s.sameStatusSince.getTime()),
        ] as const;
      });
    const groupBySameStatusSinceAsMap = new Map(groupBySameStatusSince);
    return asSuccessPromise(groupBySameStatusSinceAsMap);
  }
}
